import { Box, styled } from '@mui/material';
import styles from '../Dialogs/SurveyDialog.module.scss';
import {
  AltButton,
  Button,
  SurveyStepColumn,
  SurveyStepColumnContent,
  SurveyStepRow,
} from '../../ui';
import Checkmark from '../../img/checkmark.svg';

const Announcements202507 = () => {
  return (
    <>
      <div className={styles.Announcements} style={{ textAlign: 'center' }}>
        <SurveyStepRow className='survey-step-row'>
          <SurveyStepColumn className='survey-column-one'>
            <SurveyStepColumnContent mid>
              <ContentBox>
                <Box component={'div'} m={0} margin={0}>
                  <h2>
                    Your Voice Can Shape the Future of AHRQ Quality Indicators -{' '}
                    <span style={{ fontWeight: 'normal' }}>Take our Survey</span>
                  </h2>
                </Box>

                <Box fontSize={22} lineHeight={1.1}>
                  Less than 10 minutes of your time will help us improve the QIs.
                </Box>

                <Box>
                  Welcome to the Agency for Healthcare Research and Quality (AHRQ) Quality Indicator
                  (QI) Survey. We value feedback from both current AHRQ QI users and those who may
                  use the AHRQ QIs in the future. Your responses to this survey will be used to make
                  improvements to the AHRQ QI program.
                </Box>

                <Box>
                  For questions or technical support, please contact the AHRQ QI Technical Support
                  Team at <a href='mailto:QIsupport@ahrq.hhs.gov'>QIsupport@ahrq.hhs.gov</a>.
                </Box>

                <ButtonGroup>
                  <Button
                    label='Yes, take me to the Survey'
                    target='_blank'
                    href='https://www.surveymonkey.com/r/KFSZZN3'
                  />

                  <Box fontSize={'12px'} py='.25rem'>
                    <img src={Checkmark} alt='Check icon' height='23' width='22' />
                    By clicking yes, you are agreeing to go to a third-party platform.
                  </Box>
                </ButtonGroup>
              </ContentBox>
            </SurveyStepColumnContent>
          </SurveyStepColumn>
          <SurveyStepColumn className='survey-column-two' empty last splash='02'></SurveyStepColumn>
        </SurveyStepRow>
      </div>
    </>
  );
};

const ButtonGroup = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '0.625rem',

  '.MuiButton-root': {
    flexGrow: 1,
    flexShrink: 1,

    minHeight: 50,
  },
}));

ButtonGroup.defaultProps = {
  className: 'button-group',
};

const ContentBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),

  lineHeight: 1.1,
  width: '100%',
}));

export default Announcements202507;
